<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table
          :headers='headers'
          :items='integracoes'
          class='elevation-1'
          :search="search"
          :items-per-page="itemsPerPage"
          @update:items-per-page=" v => itemsPerPage = v"
        >
          <template v-slot:top>
            <v-toolbar flat color='white'>
              <v-toolbar-title>{{ $t('keywords.listing') }}</v-toolbar-title>
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn color='primary' dark class='mb-2' @click="editItem(null)">{{ $t('button.new') }}</v-btn>
              <ImportExportSendSoapData @import="searchAll()" />
            </v-toolbar>

            <SearchField v-model="search" />
          </template>
          <template v-slot:item.lastModified='{ item }'>
            <LastModify :date="item.lastModified" :by="item.lastModifiedBy" />
          </template>
          <template v-slot:item.actions='{ item }'>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="primary" small class='mr-2' @click='tryPlay(item)'>mdi-animation-play</v-icon>
              </template>
              <span>{{ $t('keywords.start_workflow') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="orange" small class='mr-2' @click='editItem(item)'>mdi-pencil</v-icon>
              </template>
              <span>{{ $t('button.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="red" small class='mr-2' @click='deleteItem(item)'>mdi-delete</v-icon>
              </template>
              <span>{{ $t('button.delete') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="secondary" small class='mr-2' @click='exportItem(item)'>mdi-export</v-icon>
              </template>
              <span>{{ $t('core.import_export.export') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <ShowLastLogsIcon v-on="on" :integrationName="item.jobIdentifier" processType="jobenviadadossoap" />
              </template>
              <span v-text="$t('keywords.latest_logs')" />
            </v-tooltip>
          </template>
          <template v-slot:item.active='{ item }'>
            <v-icon small color="green" v-if="item.active">mdi-circle</v-icon>
            <v-icon small color="darkgrey" v-else>mdi-circle</v-icon>
          </template>
          <template v-slot:item.nameGetParameters='{ item }'>
            <v-chip v-for="par in item.parametros"
              :key="par"
              class="mr-2"
            >
              {{par}}
            </v-chip>
          </template>
          <template v-slot:no-data>
            {{ $t('warnings.no_data_found') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import jobEnviaDadosWs from '@/services/JobEnviaDadosWsSoap'
import ImportExportService from '@/services/ImportExportService'
import ShowLastLogsIcon from '@/components/core/ShowLastLogsIcon.vue'
import LastModify from '../core/LastModify.vue'
import SearchField from '../core/SearchField.vue'
import ImportExportSendSoapData from './ImportExportSendSoapData.vue'

export default {
  name: 'jobEnviaDadosWsSoapGrid',
  components: {
    ShowLastLogsIcon,
    LastModify,
    SearchField,
    ImportExportSendSoapData
  },
  data: () => ({
    integracoes: [],
    search: ''
  }),

  mounted () {
    this.searchAll()
  },

  computed: {
    version () { return this.$versionable.versions.jobSoap },
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('jobenviadadoswssoap_per_page') ? parseInt(this.$cookies.get('jobenviadadoswssoap_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('jobenviadadoswssoap_per_page', value)
      }
    },
    headers () {
      return [
        {
          text: this.$t('keywords.id'),
          value: 'jobIdentifier',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('keywords.last_modify'),
          value: 'lastModified',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('check.active'),
          value: 'active',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false,
          align: 'center'
        }
      ].filter(h => h.show ?? true)
    }
  },

  methods: {

    searchAll () {
      jobEnviaDadosWs.findAll()
        .then((databases) => (this.integracoes = databases.data))
    },

    editItem (item) {
      this.$emit('editItem', false, item)
    },

    deleteItem (item) {
      if (confirm(this.$t('warnings.confirm.delete'))) {
        jobEnviaDadosWs.delete(item)
          .then(() => this.searchAll())
          .catch((error) => this.$message.error(`${this.$t('warnings.error.delete')} : ${error}`))
      }
    },

    tryPlay (item) {
      jobEnviaDadosWs.play(item.jobIdentifier)
        .then(({ data }) => {
          this.$message.success(this.$t('warnings.success.init'))
          this.$versionable.decorators.monitoring.showLog(data.uniqueId, data.date, data.identifier, data.processType)
        })
        .catch(erro => this.$message.error(`${this.$t('warnings.error.init')} : ${erro}`))
    },

    exportItem (item) {
      if (confirm(this.$t('warnings.confirm.export'))) {
        ImportExportService.export('jobenviodadossoaplib', item.jobIdentifier)
          .then(() => this.$message.success(this.$t('warnings.success.export')))
          .catch(error => this.$message.error(`${this.$t('warnings.error.export')} : ${error}`))
      }
    }
  }
}
</script>
